//? Map is used for caching
const lookupTablesCache = new Map();
export function getLookupTableAccount(lookupTableAddress, connection) {
    const lookupTableAddressStr = lookupTableAddress.toBase58();
    if (!lookupTablesCache.has(lookupTableAddressStr)) {
        const lookupTableAccountPromise = connection.getAddressLookupTable(lookupTableAddress);
        lookupTablesCache.set(lookupTableAddressStr, lookupTableAccountPromise);
    }
    return lookupTablesCache.get(lookupTableAddressStr);
}
